import { format } from 'date-fns';

export default function ToReadableDate(date) {
    // return format(date, 'MMMM dd, yyyy h:mm a');
    return format(date, 'MMMM dd, yyyy');
}
